export const ActionTypes = {
    RECEIVED_ASSIGNMENTS: '@@abservice/RECEIVED_ASSIGNMENTS',
    TRACKED_CONVERSION: '@@abservice/TRACKED_CONVERSION',
    CONVERSION_ERROR: '@@abservice/CONVERSION_ERROR',
};

export const OPTIMIZELY_PROJECT = 'default';
export const OPTIMIZELY_PROJECT_ID = '8426652696'; // Production
// export const OPTIMIZELY_PROJECT_ID = '8418756754'; // Staging

export const VisitorIdTypes = {
    SESSION_ID: 'sessionId',
    TRACKING_ID: 'trackingId',
};
